import httpClient from './httpClient';

export const PRODUCT_FAMILIES_ENDPOINT = '/backoffice/product-families';

export const getProductFamiliesAPI = (params = {}) => httpClient.get(PRODUCT_FAMILIES_ENDPOINT, { params });
export const getProductFamilyAPI = (id) => httpClient.get(`${PRODUCT_FAMILIES_ENDPOINT}/${id}`);
export const postProductFamilyAPI = (params) => httpClient.post(`${PRODUCT_FAMILIES_ENDPOINT}`, params);
export const updateProductFamilyAPI = (id, params) => httpClient.put(`${PRODUCT_FAMILIES_ENDPOINT}/${id}`, params);
export const deleteProductFamilyAPI = (id) => httpClient.delete(`${PRODUCT_FAMILIES_ENDPOINT}/${id}`);
